import $ from 'jquery';
window.$ = window.jQuery = $;
import Cookies from 'js-cookie';
import 'slick-carousel';
require('../../node_modules/waypoints/lib/jquery.waypoints.js');

var mobileBreakpoint = 1024;

document.getElementsByTagName('html')[0].classList.remove('no-js');

jQuery(document).ready(function($) {

	$('html').addClass(IEdetection());

	if (window.location.hash) {
		if (window.location.hash == '#thank-you') {
			$('body').addClass('has-signed-up');
			setTimeout(function() {
				window.scrollTo(0, document.body.scrollHeight);
			}, 250);
		} else if (window.location.hash == '#form-out-thank-you') {
			$('.contact-form').first().addClass('active thank-you thank-you-out');
			$('html, body').animate({
				scrollTop: $('.contact-form').first().offset().top
			}, 250);
		} else if (window.location.hash == '#form-in-thank-you') {
			$('.contact-form').first().addClass('active thank-you thank-you-in');
			$('html, body').animate({
				scrollTop: $('.contact-form').first().offset().top
			}, 250);
		}
	}

	var waypointsBody = $('.header-tagline').waypoint(function(direction) {
		$(this.element).removeClass('active');
	}, {
		offset: $('.header-main').outerHeight() - 1
	});

	var waypointsPageMainContent = $('.wrapper-inner, .featured-image-wrap').waypoint(function(direction) {
		if (!$(this.element).hasClass('active')) {
			$(this.element).addClass('active');
		}
	}, {
		offset: '100%'
	});

	var waypointsCircles = $('.circles-wrap .circle').waypoint(function(direction) {
		if (!$(this.element).hasClass('active')) {
			$(this.element).addClass('active');
		}
	}, {
		offset: '80%'
	});

	var waypointsHighlightCTAs = $('.highlight').waypoint(function(direction) {
		if (!$(this.element).hasClass('active')) {
			$(this.element).addClass('active');
		}
	}, {
		offset: '40%'
	});

	$('.nav-main-toggle').click(function() {
		if ($('body').hasClass('sub-menu-active')) {
			$('body').removeClass('sub-menu-active');
			$('.nav-panel .menu > li').removeClass('active');
		}
		$('body').toggleClass('nav-expanded');
	});

	$('.search-toggle').click(function(e) {
		if ($(window).width() >= mobileBreakpoint) {
			e.preventDefault();
			$('.sub-menu-active-wrap-inner').empty();
			$('.nav-main .menu > li').removeClass('active');
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$('body').removeClass('sub-menu-active');
			} else {
				$(this).addClass('active');
				var searchForm = $('.nav-main-inner .header-search-wrap').html();
				$('.sub-menu-active-wrap-inner').append(searchForm);
				$('body').addClass('sub-menu-active');
				$('.sub-menu-active-wrap-inner #search').focus();
			}
		}
	});

	var subMenuWrap = $('header .sub-menu-active-wrap');

	$('.nav-main .menu > li.menu-item-has-children > a').click(function(e) {
		e.preventDefault();
		$(this).parent().siblings().removeClass('active');
		$('.search-toggle').removeClass('active');
		if ($('body').hasClass('sub-menu-active') && $(this).parent().hasClass('active')) {
			$('body').removeClass('sub-menu-active');
			$(this).parent().removeClass('active');
			return;
		}

		$(this).parent().addClass('active');
		var thisParentTitle = $(this).html();
		var thisSubMenuWrap = $(this).parent().find('.sub-menu');
		thisSubMenuWrap.attr('data-child-count', thisSubMenuWrap.children().length);
		if ($(this).parent().hasClass('sub-menu-has-icons')) {
			thisSubMenuWrap.addClass('sub-menu-has-icons');
		}
		thisSubMenuWrap.wrap('</p>');

		var thisSubMenu = thisSubMenuWrap.parent().html();
		thisSubMenuWrap.unwrap();

		$('header').find('.sub-menu-active-title').remove();
		$('header').append('<div class="sub-menu-active-title"><svg class="fa-angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"/></svg>' + thisParentTitle + '</div>').promise().done(function() {
			$('.sub-menu-active-title').click(function() {
				$('body').removeClass('sub-menu-active');
			});
		});

		var subMenuWrapInner = subMenuWrap.find('.sub-menu-active-wrap-inner');
		$('body').addClass('sub-menu-active');
		subMenuWrapInner.html(thisSubMenu);
	});

	var slickDefaultOptions = {
		prevArrow: '<button class="slick-arrow slick-prev"><svg class="fa-angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"/></svg></button>',
		nextArrow: '<button class="slick-arrow slick-next"><svg class="fa-angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"/></svg></button>',
		speed: 300,
		autoplay: true,
		autoplaySpeed: 5500,
		pauseOnHover: true
	};

	$('.chat-slider').slick(slickDefaultOptions).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		$('.chat-slider .slick-slide[data-slick-index="' + currentSlide + '"]').addClass('going-away');
	}).on('afterChange', function(event, slick, currentSlide, nextSlide) {
		$('.chat-slider .slick-slide.going-away').removeClass('going-away');
	});

	$('.chat-slider').slick('slickPause');
	$('.chat-slider').addClass('paused');
	$('.chat-slider .slick-active').removeClass('slick-active');

	var slickHeroOptions = slickDefaultOptions;
	slickHeroOptions.arrows = false;
	slickHeroOptions.pauseOnHover = true;
	slickHeroOptions.dots = true;
	$('.hero-slider-wrap').slick(slickHeroOptions);

	var waypointsChatSlider = $('.block-chat-slider').waypoint(function(direction) {
		if ($(this.element).find('.chat-slider').hasClass('paused')) {
			$(this.element).find('.chat-slider').removeClass('paused');
			$('.chat-slider .slick-current').addClass('slick-active');
			$('.chat-slider').slick('slickPlay');
		}
	}, {
		offset: '40%'
	});

	$('.contact-column-list > li .contact-column-list-item-title').click(function() {
		if ($(this).parent().hasClass('active')) {
			$(this).parent().removeClass('active');
			$('.contact-forms .contact-form').removeClass('active');
			return;
		}
		if ($(this).parent().attr('data-item-type') == 'form') {
			var thisFormID = $(this).parent().attr('data-form-id');
			$('.contact-forms .contact-form').removeClass('active thank-you thank-you-in thank-you-out');
			$('.contact-forms .contact-form[data-form-id="' + thisFormID + '"]').addClass('active');
			$('html, body').animate({
				scrollTop: $('.contact-forms').offset().top - $('header').outerHeight()
			}, 250);
		}
		$('.contact-column-list > li').removeClass('active');
		$(this).parent().addClass('active');
	});

	// $('form.sf-form').submit(function(e) {
	// 	e.preventDefault();
	// 	$.ajax({
	// 		url: $(this).attr('action'),
	// 		method: $(this).attr('method'),
	// 		data: $(this).serialize(),
	// 		dataType: 'jsonp',
	// 		success: function() {
	// 			console.log('success');
	// 		}
	// 	});
	// });

	// $('form #opt-in').change(function() {
	// 	var optInTarget = $(this).parents('form').attr('data-opt-in-target');
	// 	var optOutTarget = $(this).parents('form').attr('data-opt-out-target');
	// 	if ($(this).is(':checked') && optInTarget) {
	// 		$(this).parents('form').attr('action', optInTarget);
	// 		$(this).parents('form').find('#referral-url').val(document.URL + '#form-in-thank-you');
	// 	} else if (!$(this).is(':checked') && optOutTarget) {
	// 		$(this).parents('form').attr('action', optOutTarget);
	// 		$(this).parents('form').find('#referral-url').val(document.URL + '#form-out-thank-you');
	// 	}
	// });

	if (Cookies.get('newsletter-signed-up')) {
		$('.footer-singup-cookie-wrap').hide();
	}

	$('.footer-signup form').submit(function(e) {
		Cookies.set('newsletter-signed-up', true, { expires: 30, domain: window.location.hostname });
	});

	if (!Cookies.get('cookies-acknowledged')) {
		$('.cookies-notice').addClass('active');
	}

	$('.cookies-acknowledged').click(function() {
		Cookies.set('cookies-acknowledged', true, { expires: 7, domain: window.location.hostname });
		$('.cookies-notice').removeClass('active');
	});

	document.querySelectorAll('header .nav-main .menu > li > a').forEach(function(item) {
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutationRecord) {
				item.style.removeProperty('outline');
			});
		});
		observer.observe(item, { attributes : true, attributeFilter : ['style'] });
	});

});

jQuery(window).resize(function() {
	jQuery('body').removeClass('sub-menu-active');
	jQuery('.nav-main li, .search-toggle').removeClass('active');
});

document.addEventListener('scroll', function (event) {
	if (jQuery(window).width() >= mobileBreakpoint && jQuery('body').hasClass('sub-menu-active')) {
		jQuery('body').removeClass('sub-menu-active');
		jQuery('nav .menu li').removeClass('active');
	}
});

function IEdetection() {
	var ua = window.navigator.userAgent;
	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older, return version number
		return('ie ie-' + parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10));
	}
	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11, return version number
		var rv = ua.indexOf('rv:');
		return('ie ie-' + parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10));
	}
	var edge = ua.indexOf('Edge/');
	if (edge > 0) {
		// Edge (IE 12+), return version number
		return('ie ie-' + parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10));
	}
	// User uses other browser
	return('not-ie');
}
